function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "playlist_add_FILL0_wght500_GRAD200_opsz48",
  d: "M6.393,21.65a.944.944,0,0,1-.713-.293.978.978,0,0,1-.28-.7.935.935,0,0,1,.28-.687.966.966,0,0,1,.713-.28h6.238a.978.978,0,0,1,.7.28.914.914,0,0,1,.293.688.944.944,0,0,1-.293.713.978.978,0,0,1-.7.28Zm0-4.507a.944.944,0,0,1-.713-.293.978.978,0,0,1-.28-.7.935.935,0,0,1,.28-.688.966.966,0,0,1,.713-.28H16.909a.957.957,0,0,1,.968.968.966.966,0,0,1-.28.713.935.935,0,0,1-.688.28Zm0-4.507a.944.944,0,0,1-.713-.293.978.978,0,0,1-.28-.7.959.959,0,0,1,.993-.993H16.909a.914.914,0,0,1,.688.293,1.015,1.015,0,0,1,0,1.4.914.914,0,0,1-.688.293Z",
  transform: "translate(-5.4 -10.65)",
  fill: "#05040d"
});

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.477 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.28f81540.svg";
export { ForwardRef as ReactComponent };